import React from "react";
import { FiX, FiAlertCircle, FiCheckCircle } from "react-icons/fi";

const Banner = ({ message, type, onClose }) => {
  if (!message) return null;
  return (
    <div className={`ma-banner ${type}`}>
      <span className="banner-icon">
        {type === 'error' ? <FiAlertCircle size={18} /> : <FiCheckCircle size={18} />}
      </span>
      <span className="banner-message">{message}</span>
      <button className="banner-close" onClick={onClose}>
        <FiX size={16} />
      </button>
    </div>
  );
};

export default Banner;
